import Swal from 'sweetalert2';

/**
 * Shared SweetAlert2 instance for the whole Librarian section.
 *
 * Every Librarian page imports `Swal` from here instead of from
 * 'sweetalert2' directly, so all confirm / success / error / input popups
 * share ONE look that matches the modern blue design system:
 *   - rounded shell, soft shadow, consistent typography (`.mx-swal`)
 *   - blue gradient confirm button, neutral cancel, red deny
 *   - semantic icons are left untouched, so success stays green, error red,
 *     warning amber and info blue (the "color coding" stays meaningful)
 *
 * The visual rules live in src/Layout/portal.css next to `.lib-swal`
 * (popups render at <body> level, so the styling is kept global there).
 *
 * Call sites are unchanged: `Swal.fire(...)`, `Swal.fire('Error', msg, 'error')`,
 * `await Swal.fire({ ... })` all keep working. A page that needs a one-off
 * look can still pass its own `customClass` per call — it overrides these.
 */
const LibrarianSwal = Swal.mixin({
  buttonsStyling: false,
  customClass: {
    popup: 'mx-swal',
    title: 'mx-swal__title',
    htmlContainer: 'mx-swal__body',
    actions: 'mx-swal__actions',
    confirmButton: 'mx-swal__btn mx-swal__btn--confirm',
    denyButton: 'mx-swal__btn mx-swal__btn--deny',
    cancelButton: 'mx-swal__btn mx-swal__btn--cancel',
    input: 'mx-swal__input'
  }
});

export default LibrarianSwal;
